<template>
  <b-modal size="xl" ref="modal" v-model="isShow" modal-class="e-modal e-modal-moderation" :hide-footer="true" @hide="onClose" centered>
    <template v-if="!$wait.is(`assets.${alias}.fetch`)">
      <template slot="modal-header">
        <div class="title">
          Moderating
        </div>
      </template>
      <template v-if="asset">
        <div class="modal-content-container">
          <em-modal-asset-header :asset="asset" :hint="hint" :meta="assetMeta" type="moderate"/>
        </div>
        <div class="modal-divider"></div>
        <em-moderate-steps :asset="asset" @closeModal="() => this.$refs.modal.hide()"></em-moderate-steps>
      </template>
    </template>
  </b-modal>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {convertRateToEmixtier} from '../../../utils/assets'

	export default {
		name: "em-moderate",
    props: {
		  alias: String
    },

    data() {
		  return {
        isShow: true
      }
    },

    methods: {
      ...mapActions('assets', {
        fetchAsset: 'fetchAsset',
      }),
      onClose() {
        this.$router.go(-1);
      }
    },

    watch: {
		  alias: {
		    handler(current) {
          this.fetchAsset(current)
        },
        immediate: true,
      },
    },

    computed: {
      ...mapGetters('assets', {
        getAsset: 'asset',
      }),

		  asset() {
		    return this.getAsset(this.alias);
      },

      hint() {
      return {
  title: 'How the Criteria Works',
  text: 'To ensure fair and reliable ratings, each asset is evaluated using a defined set of criteria. Moderators review submitted ratings and confirm that they follow the guidelines and reflect accurate information about the asset. The moderation process checks rating accuracy, consistency with the criteria, and whether the submission contains spam or manipulation. By participating in moderation you help maintain the integrity and trust of the rating system.',
  buttonText: 'Got It'
}
      },

      assetMeta() {
        return [
          {
            title: 'Emixtier',
            value: this.asset.rate === 0 ? 'N/A' : convertRateToEmixtier(this.asset.rate)
          },
          {
            title: 'Total Score',
            value: this.asset.rate === 0 ? 'N/A' : this.asset.rate.toFixed(1)
          },
          {
            title: 'Raters',
            value: this.asset.totalRaters
          },
          {
            title: 'Moderators',
            value: this.asset.totalModeration
          }
        ]
      }
    },

    mounted() {
      const modal = this.$refs.modal;
      const $app = this.$root.$el;

      $app.parentNode.appendChild(modal.$el);
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/moderate/moderate.vue